/*
 * Page Name
 */

(function ($) {

    var ind_block03_slider = new Swiper(".ind_block03_slider", {
        slidesPerView: 2,
        spaceBetween: 25,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true
            },
            800: {
                slidesPerView: 2,
                spaceBetween: 25,
                centeredSlides: false
            },
        }
    });

    ind_block03_slider.on('slideChangeTransitionStart', function () {
        jQuery('.ind_block03_slider .swiper-wrapper').css({transition: 'transform 1000ms ease 0s'})
    });

    _heightline({
        itemClsName: '.ind_block05_cnt_list ._item ._text',
        itemPerRow: 3,
        device: 'pc'
    });

    _heightline({
        itemClsName: '.ind_block05_cnt_list ._item ._text',
        itemPerRow: 2,
        device: 'smp'
    });


})(jQuery);